<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <CandidateJobListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import CandidateJobListing from "@/views/pages/admin/candidateJob/candidateJobListing";

export default {
    page: {
        title: i18n.t("module.job"),
    },
    components: { Layout, PageHeader, CandidateJobListing },
    data() {
        return {
            title: i18n.t("module.job"),
            items: [
                {
                    text: i18n.t("module.recruitment"),
                    href: '/recruitments',
                },
                {
                    text: i18n.t("module.job"),
                    active: true,
                },
            ],
        };
    },
}
</script>
